import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { reportSalesCumulativeGlobalTypes } from "redux/reducers/Reports/reportSalesCumulativeGlobal/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_SALES_CUMULATIVE_GLOBAL_FILTERS } = reportSalesCumulativeGlobalTypes;

export const getReportSalesCumulativeGlobalAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    dispatch(startRequestComp('loadingSalesCumulativeGlobal'));
    try {
      const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/cumulative-sales/report?idStation=${station.id}&start=${startDate}&end=${endDate}&pdf=${isPdf}`;
      const res = await axios.get(url, {
        headers: { authorization: token },
        responseType: "blob"
      });

      saveAs(res.data, `Reporte_SalesCumulativeGlobal_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingSalesCumulativeGlobal'));
    }
  };
};

export const setReportSalesCumulativeGlobalFilters = (key = "", value) => ({
  type: SET_SALES_CUMULATIVE_GLOBAL_FILTERS,
  payload: { key, value }
});
